<template>
	<div v-if="webSiteConfig" class="nav-bottom-box">
		<!--底部导航-->
		<div class="nav-bottom">
			<ul>
				<li>
					<router-link :to="{name:'home'}">网站首页</router-link>
					<img src="../assets/img/nav.png" />
				</li>
				<li>
					<a style="cursor:pointer ;" @click.stop="Switchitem('1')">网上服务</a>
					<img src="../assets/img/nav.png" />
				</li>
				<li>
					<router-link :to="{name:'Bossspeak',params:{page:'1'}}">本处简介</router-link>
					<img src="../assets/img/nav.png" />
				</li>
				<li>
					<router-link :to="{name:'contact'}">联系我们</router-link>
				</li>
			</ul>
		</div>
		<!--底部信息-->
		<div class="bottom">
			<p>主办单位：{{webSiteConfig.companyname}}</p>
			<p>地址：{{webSiteConfig.companyaddress}} &nbsp;联系电话：{{webSiteConfig.companytel}}</p>
			<p style="cursor:pointer;" @click="gotourl">备案号：{{webSiteConfig.record}}  &nbsp;&nbsp;&nbsp;&nbsp;{{webSiteConfig.copyright}}</p>
		</div>
	</div>
</template>

<script>
	import {
		global
	} from '../api/index.js'
	export default {
		name: "headinfo",
		data() {
			return {
				grt:"hello",
				ho:new Date().getHours(),
				nowTime: '',
				nowWeek: '',
				title:'',
				open: false,
				open2:false,
				open3:false,
				loginform: {},
				loginrules: {
					name: [{
							required: true,
							message: '请输入手机号',
							trigger: 'blur'
						},
						{
							min: 11,
							max: 11,
							message: '手机号长度在11个字符',
							trigger: 'blur'
						}
					],
					pass: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					]
				},
				regform:{},
				regrules:{},
				hoturl: '/cxWebApi/profile',
				webSiteConfig:null,
			}
		},
		created() {
			this.getglobal();
		},
		methods: {
			gotourl(){
				window.open('https://beian.miit.gov.cn','_blank');
			},
			Switchitem(row){
				let obj = JSON.parse(sessionStorage.getItem('webopenId'));
				if(obj==null){
					this.$message.error('请先登陆！');
				}else{
					this.$router.push({name:'serve',params: {page:row}}).catch(err =>{})
				}
			},
			getglobal(){
				global().then(res=>{
					this.webSiteConfig = res.data.webSiteConfig
				})	
				// this.webSiteConfig = JSON.parse(sessionStorage.getItem('webSiteConfig'))
			},
		},
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
	@import "../assets/css/sliderx.css";
	@import "../assets/css/login.css";
</style>
